const isPolishVersion = (locale) => locale === 'pl'

export default isPolishVersion
